var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('a',{staticClass:"skip-link",attrs:{"href":"#main"}},[_vm._v("Skip to content")]),_c('Menu'),_c('main',{staticClass:"content",attrs:{"id":"main","tabindex":"-1"}},[_c('router-view')],1),_c('Contact'),_c('MGBenefitCalculator'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }